<template>
  <div class="flex m-8 justify-start flex-wrap">
    <div class="md:max-w-xs w-full mb-4 md:mb-0">
      <p class="pb-2 text-gray-500 font-medium">Escenarios</p>
      <p class="text-sm text-gray-400">
        En esta sección podrás indicar los materiales de la construcción. Una
        vez que tengamos esos datos, puedes comparar entre varios escenarios,
        con diferentes materiales. Al final te entregaremos un reporte donde
        podrás identificar cada escenario y su información.
      </p>
    </div>

    <div class="flex-1 md:ml-5">
      <div class="flex w-full flex-wrap">
        <scenario
          v-for="(scenario, index) in scenarios"
          class="max-w-xs"
          :number="index + 1"
          :key="index"
          :material="material"
          :scenario="scenario"
          @scenario-removed="scenarioRemoved"
        ></scenario>
        <div
          @click="$emit('adding-scenario')"
          :class="{
            'border-red-300 text-red-900 placeholder-red-300 hover:border-gray-800':
              $v.scenarios.$error,
            'hidden' : scenarios.length >= 3,
          }"
          class="inline-flex items-center px-4 py-2 border border-gray-700 leading-5 font-medium rounded-md hover:text-white bg-white text-gray-600 hover:bg-gray-600 focus:outline-none focus:shadow-outline-gray focus:border-gray-800 transition duration-150 ease-in-out mb-4 cursor-pointer min-h-64 md:min-w-xs mr-4"
        >
          <div
            class="h-full w-full flex flex-col items-center justify-center flex-wrap"
          >
            <svg viewBox="0 0 20 20" fill="currentColor" class="w-8 mb-2">
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                clip-rule="evenodd"
              />
            </svg>

            <p class="w-40 text-center mx-4">
              Agregar escenario
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';

export default {
  props: {
    scenarios: { type: Array },
    material: {},
  },
  validations() {
    return {
      scenarios: {
        required,
        minLength: minLength(1),
      },
    };
  },
  methods: {
    scenarioRemoved(scenario) {
      this.$emit('scenario-removed', scenario);
    },
  },
};
</script>
